import { useCallback } from 'react';
import { paymentModel } from 'entities/payment';
import { selectAwaitingPayment, selectCurrentPaymentAsset } from 'entities/payment/model';
import { useAppDispatch, useInterval, useShallowSelector } from 'shared/hooks';
import { getToastMessage } from 'shared/lib';
import { useStepper } from 'shared/ui';

import { STEPPER_ROUTES } from '../lib/stepper';

interface UsePaymentMonitorOptions {
  timeoutRoute?: string;
  intervalMs?: number;
}

export const usePendingPayment = (options?: UsePaymentMonitorOptions) => {
  const { timeoutRoute = STEPPER_ROUTES.PAYMENT_INITIAL, intervalMs = 12_000 } = options ?? {};

  const dispatch = useAppDispatch();
  const { replace } = useStepper();

  const payment = useShallowSelector(selectAwaitingPayment);
  const paymentToken = useShallowSelector(selectCurrentPaymentAsset);

  const pollPaymentStatus = useCallback(() => {
    dispatch(paymentModel.thunks.checkPaymentRequest());
  }, [dispatch]);

  const onExpired = useCallback(() => {
    getToastMessage('error', 'Your payment has expired');
    replace(timeoutRoute);
  }, [replace, timeoutRoute]);

  useInterval(pollPaymentStatus, intervalMs);

  return { payment, paymentToken, onExpired };
};
